<script>
import { mapActions } from 'vuex';
import RbxDatePicker from '@/shared/reybex/RbxDatePicker';
import downloader from '@/mixins/downloader';
import mainViewTabMixin from '@/mixins/mainViewTab';
import snackbarMixin from '@/mixins/snackbar';

export default {
  name: 'ActivityReport',
  components: {
    RbxDatePicker,
  },
  mixins: [mainViewTabMixin, snackbarMixin, downloader],
  data() {
    return {
      startDate: undefined,
      endDate: undefined,
      text: '',
      isDownloading: false,
    };
  },
  created() {

  },
  methods: {
    ...mapActions('activityReport', ['downloadReport']),
    _downloadReport() {
      if (!(this.startDate && this.endDate)) {
        this.showErrorMessage('Bitte tragen Sie ein Start- und End-Datum ein.');
      } else {
        this.isDownloading = true;

        this.downloadReport({
          startDate: this.startDate,
          endDate: this.endDate,
          text: this.text,
        })
          .then((response) => {
            this.getDownloadContent(response, 'activity_report.pdf');
          })
          .catch(() => {
            this.showErrorMessage('Bei der Erstellung des Berichts ist ein technischer Fehler aufgetreten.');
          })
          .finally(() => {
            this.isDownloading = false;
          });
      }
    },
    onStartDateInput(newDate) {
      this.startDate = newDate;
    },
    onEndDateInput(newDate) {
      this.endDate = newDate;
    },
  },
};
</script>

<template>
  <div class="user-detail">

    <v-toolbar dark dense height="40" color="blue-grey lighten-2">
      <v-tooltip bottom>
        <v-btn
          @click.native="_downloadReport" flat icon slot="activator" :disabled="isDownloading">
          <v-icon small>cloud_download</v-icon>
        </v-btn>
        <span>Bericht herunterladen</span>
      </v-tooltip>
    </v-toolbar>

    <v-form>
      <v-container fluid grid-list-lg pt-2 pa-0>
        <v-layout row wrap>
          <v-flex md4>
            <rbx-date-picker label="Beginn" :value="startDate" @input="onStartDateInput" />
          </v-flex>

          <v-flex md4>
            <rbx-date-picker label="Ende" :value="endDate" @input="onEndDateInput" />
          </v-flex>
        </v-layout>

        <v-layout row wrap>
          <v-flex md12>
            <v-textarea
              v-model="text"
              label="Notizen"
              class="caption"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>
